import { defineStore } from 'pinia'
import { ref, computed, watch, onMounted, type Ref } from 'vue'
import { get as idbGet, set as idbSet, del as idbDel } from 'idb-keyval'


export const DEFAULT_TAGS = ['image', 'meme', 'generated'] as const
export type DefaultTags = (typeof DEFAULT_TAGS)[number]
export type Tag = DefaultTags | (string & {})

export function handleAddTag(
  tag: string,
  tagStore: ReturnType<typeof useTagStore>
) {
  if (tag && tagStore.availableTags.includes(tag as Tag)) {
    tagStore.select(tag as Tag)
  }
}

export const useTagStore = defineStore('tags', () => {
  // transient suggestions
  const tags: Ref<Record<Tag, boolean>> = ref({})
  // master list of all tags
  const allTags: Ref<Record<Tag, boolean>> = ref({})
  // currently selected tags
  const selected: Ref<Tag[]> = ref([])

  
  watch(
  selected,
  (newVal) => {
    if (newVal.length === 0) {
      // @ts-ignore
      select('Home')
    }
  }
)



  //Hydrate selected from IndexedDB once
  onMounted(() => {
    idbGet<Tag[]>('selectedTags')
      .then((val) => {
        if (Array.isArray(val)) selected.value = val
      })
      .catch(() => {})
  })

  //Persist changes to selectedtags back to IndexedDB
  watch(
    selected,
    (newVal) => {
      const clean = [...newVal]
      idbSet('selectedTags', clean).catch(() => {})
    },
    { deep: true }
  )

  const availableTags = computed(() =>
    Object.keys(tags.value).filter(
      (t) => !selected.value.includes(t as Tag)
    )
  )

  function select(tag: Tag) {
    if (!selected.value.includes(tag)) {
      selected.value = [...selected.value, tag]
    }
  }

  function unselect(tag: Tag) {
    if (selected.value.includes(tag)) {
      selected.value = selected.value.filter((t) => t !== tag)
    }
  }

  function unselectAll() {
    selected.value = []
    idbDel('selectedTags').catch(() => {})
  }

  function fetchTags(query: string) {
    if (!query) {
      tags.value = {}
      return
    }
    Object.keys(allTags.value)
      .filter((t) => t.toLowerCase().startsWith(query.toLowerCase()))
      .forEach((t) => {
        tags.value[t as Tag] = true
      })
  }

  return {
    tags,
    allTags,
    selected,
    availableTags,
    select,
    unselect,
    unselectAll,
    fetchTags,
  }
})
